// @flow
import styled from '@emotion/styled';
import { SPACING, typography } from '@tablekit/theme';
import type { DocType } from 'components/types';
import ExpandAnimation from 'components/ExpandAnimation';
import RichText from 'components/RichText';
import Card from 'styled/Card';
import { MOBILE_BREAKPOINT, MOBILE_MAX_WIDTH } from 'utils/theme';

type PropsType = {
  isDesktopOnly?: boolean,
  isMobileOnly?: boolean,
  isOpen: boolean,
  text: DocType
};

const getOpenStyles = () => {
  const initialWindowWidth =
    typeof window !== 'undefined'
      ? Math.min(window.outerWidth, window.innerWidth)
      : 0;
  const isMobile = initialWindowWidth <= MOBILE_MAX_WIDTH;
  return {
    height: 'auto',
    opacity: 1,
    overflow: 'visible',
    marginTop: isMobile ? parseInt(SPACING.L4, 10) : parseInt(SPACING.L6, 10)
  };
};

const getClosedStyles = () => ({
  height: 0,
  opacity: 0,
  overflow: 'hidden',
  marginTop: 0
});

const SummaryAnimator = styled(ExpandAnimation)`
  margin: 0 -20px;
  padding: 0 20px;
`;

const SummaryCard = styled(Card)`
  ${typography('L3')};
  padding: ${SPACING.L6};
  @media ${MOBILE_BREAKPOINT} {
    ${typography('L1')};
    padding: ${SPACING.L4};
  }
  width: 100%;
  min-height: auto;
  max-height: none;

  ul,
  ol {
    list-style: inside;
  }
  li > * {
    display: inline-block;
    vertical-align: text-top;
  }
  > p,
  li:not(:last-of-type) {
    margin-bottom: ${SPACING.L3};
  }
`;

const SummaryPanel = ({
  text,
  isOpen,
  isMobileOnly,
  isDesktopOnly
}: PropsType) => {
  if (!text) return null;
  return (
    <SummaryAnimator
      isMobileOnly={isMobileOnly}
      isDesktopOnly={isDesktopOnly}
      isOpen={isOpen}
      openStyles={getOpenStyles}
      closedStyles={getClosedStyles}
    >
      <SummaryCard>
        <RichText richText={text} />
      </SummaryCard>
    </SummaryAnimator>
  );
};

export default SummaryPanel;
